import { Pipe } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'currencySymbolSpace'
})
export class CurrencySymbolSpacePipe extends CurrencyPipe {

  transform(value: number, ...args: any[]): any {
    if (value) {
      value = +value.toString().replace(/,/g, "");
      return super.transform(value, ...args).replace(/([^\d.,])(\d)/, "$1 $2");
    }
  }

}
